import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  CACHE_PREVIOUS_CATEGORY_IDS,
} from "../../constants/actionTypes";

export const categoriesInitialState = {
  isFetching: false,
  categories: [],
  selectedCategoryIds: [],
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case CACHE_PREVIOUS_CATEGORY_IDS: {
      return {
        ...state,
        selectedCategoryIds: payload || [],
      };
    }
    case GET_CATEGORIES_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categories: payload,
        isFetching: false,
      };
    }
    case GET_CATEGORIES_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
